import {
  SegmentActionName,
  SegmentObjectName,
  track,
  TrackingEventName,
  trackLegacyEvent,
} from '@heidi/analytics/events';

export function trackSnippetCreated(input: {
  contentLength: number;
  shorthandLength: number;
  from: 'editor' | 'settings' | 'dictation';
}) {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.CreateSnippet,
      contentLength: input.contentLength,
      shorthandLength: input.shorthandLength,
      from: input.from,
    },
  });

  // V2 — Amplitude migration
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SnippetCreated,
    props: {
      content_length: input.contentLength,
      shorthand_length: input.shorthandLength,
      source: input.from,
    },
  });
}

export function trackSnippetDeleted(input: {
  snippetId: string;
  from: 'editor' | 'settings' | 'dictation';
}) {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.DeleteSnippet,
      snippetId: input.snippetId,
      from: input.from,
    },
  });

  // V2 — Amplitude migration
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SnippetDeleted,
    props: {
      snippet_id: input.snippetId,
      source: input.from,
    },
  });
}

export function trackSnippetEdited(input: {
  snippetId: string;
  contentLength: number;
  shorthandLength: number;
  from: 'editor' | 'settings' | 'dictation';
}) {
  trackLegacyEvent({
    name: SegmentObjectName.General,
    props: {
      action: SegmentActionName.EditSnippet,
      snippetId: input.snippetId,
      contentLength: input.contentLength,
      shorthandLength: input.shorthandLength,
      from: input.from,
    },
  });

  // V2 — Amplitude migration
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.SnippetUpdated,
    props: {
      snippet_id: input.snippetId,
      content_length: input.contentLength,
      shorthand_length: input.shorthandLength,
      source: input.from,
    },
  });
}
